import {ICON_TYPES} from '../constants';
import {IconPropsType} from '../IconProps.type';
export const RightArrowIcon = (props: IconPropsType): JSX.Element => {
  const svgProps = {
    width: props.width || '7',
    height: props.height || '12',
    fill: props.fill || '#E35205',
  };
  return (
    <svg
      width='7'
      height='12'
      viewBox='0 0 7 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M0.328772 10.9798C0.123747 11.1751 0.123747 11.4916 0.328772 11.6869C0.533797 11.8821 0.866211 11.8821 1.07123 11.6869L0.328772 10.9798ZM6.3 6L6.67123 6.35356C6.76969 6.25979 6.825 6.13261 6.825 6C6.825 5.8674 6.76969 5.74022 6.67123 5.64645L6.3 6ZM1.07123 0.313118C0.866211 0.117856 0.533797 0.117856 0.328772 0.313118C0.123747 0.50838 0.123747 0.824965 0.328772 1.02022L1.07123 0.313118ZM1.07123 11.6869L6.67123 6.35356L5.92877 5.64645L0.328772 10.9798L1.07123 11.6869ZM6.67123 5.64645L1.07123 0.313118L0.328772 1.02022L5.92877 6.35356L6.67123 5.64645Z'
        fill={svgProps.fill}
      />
    </svg>
  );
};

RightArrowIcon.iconType = ICON_TYPES.RIGHTARROW;
